import MultiselectField from './multiselect'

export default MultiselectField


// WEBPACK FOOTER //
// ./src/components/fields/multiselect/index.js